import React from 'react';
import SvgIcon from "../icon/SvgIcon";
import PropTypes from 'prop-types';

const ListSorter = ({name, displayName, sortBy, sortDescending, onClick}) => {
  let active = sortBy === name;
  return (
    <span className={"sorter " + (active ? 'active' : '')} onClick={onClick}>
      <span className="sort-control">
        <SvgIcon icon={active ? (sortDescending ? 'sort-descending' : 'sort-ascending') : 'sort-default'} color='gray-medium'/>
      </span>
      {displayName}
    </span>
  );
};

ListSorter.propTypes = {
  name: PropTypes.string.isRequired, // Variable name with which sorting happens and active sorter style gets changed
  displayName: PropTypes.string.isRequired, // Display name on the sorting element on the UI
  sortBy: PropTypes.string.isRequired,
  sortDescending: PropTypes.bool.isRequired,
  onClick: PropTypes.func
};


export default ListSorter;
